module.exports = __webpack_public_path__ + "static/scale-model-of-tribute-to-children-in-pittsburgh-pennsylvania-e64761e48ecf10faa3c19d20e4f8f32b.png";